/** Keep PrimeNG's body lock only while a live overlay still needs it. */
export function reconcileOverlayScrollLock(document: Document, excluded?: Element, scrollbarWidth?: string): void {
  const view = document.defaultView;
  if (typeof window === 'undefined' || !view || !document.body) return;
  const hasOwner = Array.from(document.querySelectorAll(
    '.p-dialog-mask, .p-sidebar-mask.p-component-overlay, .p-galleria-mask, .p-image-mask'
  )).some(element => element !== excluded && element.isConnected
    && !element.hasAttribute('data-app-modal-closing')
    && !element.classList.contains('p-component-overlay-leave')
    && view.getComputedStyle(element).display !== 'none'
    && (!element.classList.contains('p-dialog-mask')
      || element.classList.contains('p-component-overlay')
      || element.classList.contains('p-dialog-mask-scrollblocker')
      || !!element.querySelector('.p-dialog-maximized')));

  document.body.classList.toggle('p-overflow-hidden', hasOwner);
  if (hasOwner) {
    document.body.style.setProperty('--scrollbar-width', scrollbarWidth
      || document.body.style.getPropertyValue('--scrollbar-width')
      || `${view.innerWidth - document.documentElement.clientWidth}px`);
  } else {
    document.body.style.removeProperty('--scrollbar-width');
  }
}
